import * as React from 'react'
import Select from 'react-select'
import { Route, Link, RouteComponentProps, Redirect } from 'react-router-dom'
import { IActiveTripResponseV2, IDropOffNote, ITripEdit } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import Modal from '../../../ui/Modal'
import { Input } from 'src/components/ui/Forms'
import { tripsHistory } from 'src/state/selectors'
interface IDriverDNoteModalProps extends RouteComponentProps<any> {
  currentTripId: string
  endMileage: string
  history: any
  match: any
  saveNote: (params: IDropOffNote) => Promise<any>
}

interface IDriverDNoteModalState {
  isSubmitting: boolean
  error: string
  isModalOpen: boolean
  dropOffNote: string
  redirect: boolean
}

class DriverDNoteModal extends React.Component<IDriverDNoteModalProps, IDriverDNoteModalState> {
  constructor(props: IDriverDNoteModalProps) {
    super(props)
    this.state = {
      isSubmitting: false,
      error: '',
      isModalOpen: false,
      dropOffNote: '',
      redirect: false
    }
  }
  public componentDidMount() {
    this.setState({
      dropOffNote: this.props.endMileage
    })
  }
  public render() {
    const { currentTripId, endMileage } = this.props
    //TODO: Editing of Notes
    const saveText = this.state.isSubmitting ? 'Saving...' : UIMessages.common.addNote
    if (this.state.redirect === true) {
      return <Redirect to={`/trips/${this.props.currentTripId}`} />
    }
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='bg-white col-3 p2'>
            <span className='ModalAddTitle font-small weight-300 font-grey2 ml2 mr2 uppercase'>
              {UIMessages.common.DropoffNote}
              {/* <div className='ModalAddTitle font-small weight-300 font-grey2 ml2 mr2 uppercase' style={{color: 'red', fontSize: '15'}}>{currentTripId}</div> */}
            </span>
            <div
              style={{
                pointerEvents: this.state.isSubmitting ? 'none' : 'auto',
                opacity: this.state.isSubmitting ? 0.4 : 1.0
              }}
              className='ml2 mr2 mt1'
            >
              <div className='mb1 mt1'>
                <span className='font-grey3 h5'>{UIMessages.common.Note}</span>
                <input
                  type='Text'
                  name='dNote'
                  defaultValue={endMileage}
                  className='form-control'
                  onChange={this.onChange}
                />
              </div>
            </div>
            <div className='flex items-center justify-end mt3'>
              <button
                type='button'
                onClick={this.handleCancelClick}
                disabled={this.state.isSubmitting}
                className='CancelButton btn bg-white rounded font-light-grey mr2'
              >
                {UIMessages.common.cancel}
              </button>
              <button
                type='button'
                onClick={() => {
                  this.saveDropOffNote()
                }}
                disabled={this.state.isSubmitting}
                className='SubmitButton btn bg-green rounded font-white weight-300'
              >
                {saveText}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private handleCancelClick = () => {
    this.props.history.push(`${this.props.history.goBack()}`)
    this.setState({ isModalOpen: false })
  }

  private onChange = (e: any) => {
    this.setState({
      dropOffNote: `${e.target.value}`
    })
  }

  private async saveDropOffNote() {
    const params: IDropOffNote = {
      prevEndMileage: this.props.endMileage ? this.props.endMileage : ' ',
      endMileage: this.state.dropOffNote,
      dropOffFlag: 1
    }
    await this.props.saveNote(params)
    this.setState({
      redirect: true
    })

    /*  //Audit Trail
    const params1: ITripEdit = {
      notes: this.state.dropOffNote,
      prevNotes: this.props.endMileage
    }
    await this.props.saveData(params1) */
  }
}

export default DriverDNoteModal



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/note-modal/DriverDnoteModal.tsx